import React from 'react';
import ActivityCard from './ActivityCard';
import LoadingSpiner from './LoadingSpiner';

import { fetchActivitiesOfCollection } from './actions';
import { AFFILIATE_API_PATH } from "./actions/constant";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";


class ActivityList extends React.Component{
    componentWillReceiveProps(nextProps){
        if(this.props.match.params.collection !== nextProps.match.params.collection){
            var collectionId = nextProps.match.params.collection;
            var affiliateId = nextProps.match.params.username;
            this.props.fetchData(AFFILIATE_API_PATH+'getCollectionActivities.php?id='+collectionId+'&affiliateUrl='+affiliateId);
        }
    }
    componentDidMount(){
        var collectionId = this.props.match.params.collection;
        var affiliateId = this.props.match.params.username;
        this.props.fetchData(AFFILIATE_API_PATH+'getCollectionActivities.php?id='+collectionId+'&affiliateUrl='+affiliateId);
    }
    render(){
        let affiliateName = this.props.match.params.username;
        let indents = [];
        let activities;
        if(this.props.filters.status){
            activities = this.props.filters.activities;
        }else{
            activities = this.props.activities;
        }
        activities.forEach( function(element, index){
            indents.push(<ActivityCard key={element.activity_id}
              activityUrl={element.url}
              activityImage={element.image}
              activityName={element.activity_name}
              location={element.location}
              startPoint={element.starting_point}
              minBooking={element.members}
              duration={element.duration}
              nextAvailable={element.next}
              price={element.price}
              priceFor={element.price_type}
              instantBooking={element.instant_booking}
              guaranteedDeparture={element.guaranteed_departure}
              discount={element.discount}
              rating={element.rating}
              reviewCount={element.review_count}
              oldPrice = {element.old_price}
              className={(index === 0)?'first-activity-card':''}
              affiliateName = {affiliateName}
          />);
        });
        return (
            <div className="row">
                <div className="col-xl-12 offset-sm-1 col-sm-10 col-lg-12 col-md-12">
                    <p style={{margin:'0 0 1rem'}}>{indents.length} Activities &amp; Tours</p>
                </div>
                { this.props.contentLoading &&
                    <LoadingSpiner active={this.props.contentLoading}/>
                }
                {indents.length > 0 &&
                    indents
                }
                {indents.length === 0 && !this.props.contentLoading && 
                    <div style={{width:'100%','display':'flex',justifyContent:'center',marginTop:'2rem'}}>
                        <h1>No activity found.</h1>
                    </div>
                }
            </div>
        );
    }
}
const mapStateToProps = (state, ownProps) => {
    return {
        activities: state.activities,
        filters: state.filters,
        contentLoading: state.contentLoading,
        pageLoading: state.pageLoading
    };
};

const mapDispatchToProps = (dispatch) => {
        console.log("1111111");
    return {
        fetchData : (url) => dispatch(fetchActivitiesOfCollection(url))
    };
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ActivityList));


// WEBPACK FOOTER //
// ./src/ActivityList.jsx